var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from './Icon';
export var SuccessIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M8.47 18.357L20.142 4.192a.454.454 0 0 1 .684-.067c.206.19.233.53.06.757L8.643 19.817a.494.494 0 0 1-.773-.007L3.12 13.805a.578.578 0 0 1 .046-.758.454.454 0 0 1 .685.05l4.155 5.255a.296.296 0 0 0 .464.005z" }))); };
//# sourceMappingURL=SuccessIcon.js.map